/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGetTestAccountList, apiUsdkDelTestAccount } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'testAccount',
  props: {
    active: {
      type: String,
      default: 'testAccount'
    },
    gameInfo: {
      type: Object,
      required: true
    },
    height: {
      type: Number
    }
  },
  setup(__props) {
    const props = __props;
    const columns = [{
      label: '用户名',
      prop: 'account'
    }, {
      label: '额度/总额度',
      prop: 'all_balance',
      slot: 'all_balance'
    }, {
      label: '密码',
      prop: 'password'
    }, {
      label: '操作',
      action: true
    }];
    const getTableData = async () => {
      tableLoading.value = true;
      apiUsdkGetTestAccountList({
        gid: props.gameInfo.Id
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data.list;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const handleDel = row => {
      ElMessageBox.confirm(`是否确认删除【${row.account}】?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiUsdkDelTestAccount({
          id: row.id
        }).then(res => {
          if (res.code === 0) {
            getTableData();
          }
        });
      }).catch(() => {
        //
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    watch(() => [props.active, props.gameInfo], val => {
      if (val[0] === 'testAccount') {
        getTableData();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "testAccount"
      }, {
        default: _withCtx(() => [_createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          height: __props.height
        }, {
          all_balance: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(scope.row.balance) + "￥ / " + _toDisplayString(scope.row.all_balance) + "￥ ", 1)]),
          action: _withCtx(({
            scope
          }) => [_createVNode(_component_el_button, {
            link: "",
            type: "danger",
            onClick: $event => handleDel(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 8, ["data", "loading", "height"])]),
        _: 1
      });
    };
  }
});